import React from "react";
import {
    Modal,
    Text
} from "@fluentui/react";
import { Delete24Regular } from "@fluentui/react-icons";
import { ActionButton } from "../ActionButton";
import styles from "./ConfirmDeleteModal.module.css";

interface Props {
    isOpen: boolean;
    sourceName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmDeleteModal = ({ isOpen, sourceName, onConfirm, onCancel }: Props) => {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onCancel}
            isBlocking={true}
            containerClassName={styles.modal}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <Delete24Regular className={styles.icon} />
                    <Text variant="xLarge" className={styles.title}>
                        Confirmación
                    </Text>
                </div>

                <div className={styles.body}>
                    <Text variant="medium">
                        ¿Estás seguro de que deseas remover todas las publicaciones?
                    </Text>
                </div>

                <div className={styles.footer}>
                    <ActionButton
                        variant="secondary"
                        onClick={onCancel}
                        className={styles.footerButton}
                    >
                        Cancelar
                    </ActionButton>
                    <ActionButton
                        variant="danger"
                        onClick={onConfirm}
                        className={styles.footerButton}
                    >
                        Remover
                    </ActionButton>
                </div>
            </div>
        </Modal>
    );
};